module.exports = "../../app/cells/pages/landing_xray/index/choose_cell.rb";